import React,{useEffect,useState} from "react";
import unsplash from "../api/unsplash";
import { DataGrid,itIT,GridCellEditStopReasons  } from '@mui/x-data-grid';
import { CModal,CModalHeader,CModalBody,CModalTitle,CModalFooter,CButton,CForm } from '@coreui/react';
import {TextField,Button,Box,Typography,Tab,Tabs,Paper,Grid,Checkbox,FormControlLabel,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Alert,Dialog,DialogActions,DialogContent,DialogContentText, DialogTitle   } from '@mui/material'



const Mansioni = (props) => {
const [mansioni,setMansioni] =useState([]);
const [loaded,setLoaded] = useState(false);

const handleSaving = async(operazione,mansione,after,before) => {
  //after sono i rischi aggiornati
  //before sono i rischi vecchi se presenti
if(operazione==="Inserimento"){

try{
  const responseMansioniNew = await unsplash.post('mansioni',{mansione:mansione,cliente:props.idAzienda},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }});
  const responseRischiNew = await unsplash.post('rischi',{mansione:mansione,cliente:props.idAzienda,after:after},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }});




  let responseMansioni =  await unsplash
  .get('mansioni',{ headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  },params:{id:props.idAzienda}}
   );

await setMansioni(responseMansioni.data.data);
alert("Inserimento avvenuto con successo");
}catch{

  alert("errore durante l'inserimento");
}
}else{

 try{ 
  const responseRischiNew = await unsplash.post('rischi',{mansione:mansione,cliente:props.idAzienda,after:after,before:before},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }});
  alert("Modifica avvenuta con successo");
 }catch{

  alert("errore durante la Modifica");
 }



}

}

    const columns = [
        { field: 'Descrizione', headerName: 'Descrizione', width: 300 },
        { field: 'ID', headerName: '', hide: false, width :"130",
        renderCell: (params) => ( 
 <Modal title="Modifica" tipologia="Inserimento" mansioni={mansioni} selezionata={params.row.Mansione} cliente={props.idAzienda} myFunction={(operazione,mansione,after,before) => handleSaving(operazione,mansione,after,before)}></Modal>        
        )
      },
      { field: 'PianoS', headerName: '', hide: false, width :"180",
        renderCell: (params) => (
          <ProtocolloSanitario title="Protocollo Sanitario" mansione={params.row.Mansione} descrizione={params.row.Descrizione} cliente={props.idAzienda} />
        )}];




    useEffect( async () => { //carico le mansioni del cliente

  
        let responseMansioni =  await unsplash
          .get('mansioni',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:props.idAzienda}}
           );

    await setMansioni(responseMansioni.data.data);
    setLoaded(true);

},[]);
    return <div>


    {
   !loaded?
   "":
   <>
   <Modal  title="Aggiungi" tipologia="Inserimento" mansioni={mansioni} selezionata="NO" cliente={props.idAzienda}  myFunction={(operazione,mansione,after,before) => handleSaving(operazione,mansione,after,before)}></Modal>
   <div style={{ height: 400, width: '100%' }}>
   <DataGrid
   style={{marginTop:"10px"}}
         localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
         rows={mansioni}
         getRowId={mansioni => mansioni.ID}
         columns={columns}
         disableSelectionOnClick
         onSelectionChange={(newSelection) => {
          // setRighe(newSelection.rows);
       }}
       />
      
       </div>
       </>
    }
    
       </div>
   
}




//MODAL
const Modal = (props) => {
  const [visible, setVisible] = useState(false);
  const [mansioniVisibili,setMansionVisibili] = useState([]);
  const [rischi,setRischi]=useState([]);
  const [rischiSel,setRischiSel]=useState([]);
  const [mansione,setMansione]=useState(0);
  const [rischiConfronto,setRischiConfronto]=useState([]);

const handleOpen = async() => {

  setRischiSel([]);

  let responseRischi =  await unsplash
  .get('rischi',{ headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  },params:{mansione:-1,cliente:-1}}
   );
  await setRischi(responseRischi.data.data);

  

  

  let responseMansioni =  await unsplash
    .get('mansioni',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },params:{id:-1}}
     );
 
    setMansionVisibili(responseMansioni.data.data.filter(item => 
      !props.mansioni.some( mans => mans.Mansione === item.ID)
       )
  );


  //da tenere
  if(props.selezionata!=="NO"){
      
    let responseRischiSel =  await unsplash
    .get('rischi',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },params:{mansione:props.selezionata,cliente:props.cliente}}
     );
     let arr =  responseRischiSel.data.data.map(a => a.Rischio);
    await setRischiSel(arr);
    await setRischiConfronto(arr);
    }
}

const handleSaveModal = () => {
let operazione = props.selezionata==="NO"?"Inserimento":"Modifica";

  props.myFunction(operazione,props.selezionata==="NO"?mansione:props.selezionata,rischiSel,rischiConfronto);
}
  

  return (
    <>
    <CButton onClick={() =>{handleOpen();setVisible(!visible)}}>{props.title}</CButton>
    <CModal alignment="center" size="lg" visible={visible}  onClose={() => setVisible(false)}>
      <CModalHeader>
        <CModalTitle>Inserimento</CModalTitle>
      </CModalHeader>
      <CModalBody>
      {props.selezionata!=="NO"? <TextField
          id="outlined-read-only-input"
          label="Mansione"
          fullWidth
          defaultValue={props.mansioni.filter(item => item.Mansione===props.selezionata)[0]?.Descrizione}
          InputProps={{
            readOnly: true,
          }}
        />
        :
      <FormControl fullWidth>
  <InputLabel id="demo-multiple-name-label">Mansione</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          onChange={(e) =>setMansione(e.target.value)}
          input={<OutlinedInput label="Name" />}
        >
          {mansioniVisibili?.map((mansione) => (
            <MenuItem
              key={mansione.ID}
              value={mansione.ID}
            
            >
              {mansione.Descrizione}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
      
}
        <Grid container spacing={2} sx={{marginTop:"10px"}}>
        {
          
          rischi?.map((rischio) => {

return <Grid item xs={12} md={4}>
<FormControlLabel key={rischio.ID} control={<Checkbox name={rischio.Descrizione} checked={rischiSel.includes(rischio.ID)}  onClick={(e)=> { 
if(e.target.checked){
  let y = [...rischiSel];
  y.push(rischio.ID);
 
  setRischiSel(y);
}else{
  let index = rischiSel.indexOf(rischio.ID);
  let y = [...rischiSel];
  if (index > -1) {
  y.splice(index,1);
  setRischiSel(y);
}
}

 } }/>} 
  
  label={rischio.Descrizione} />
</Grid>
          })
        }
       </Grid>
       
        </CModalBody> 

      <CModalFooter>
        <CButton color="secondary" onClick={() => setVisible(false)}>
          Chiudi
        </CButton>
        <CButton color="primary"  onClick={() => handleSaveModal()}>Salva</CButton>
      </CModalFooter>
    </CModal>
  </>
  );
}



//PROTOCOLLO SANITARIO
const ProtocolloSanitario = (props) => {
  const [visible, setVisible] = useState(false);
  const [protocollo,setProtocolloSanitario] = useState([]);
  const [elencoAccertamenti,setElencoAccertamenti] = useState([]);
  const [accertamento,setAccertamento] = useState({Accertamenti:0,Cadenze:0,LineeGuida:"",ID:0})
  const [open, setOpen] = React.useState(false);

  const columns = [
    { field: 'ID', headerName: 'ID',hide:true },
    { field: 'Descrizione', headerName: 'Accertamenti', width: 300 },
    { field: 'Cadenze', headerName: 'Cadenze', width: 300 },
    { field: 'LineeGuida', headerName: 'Linee Guida', width: 300  },
  ]
  


const handleOpen = async() => {
  let acc = {...accertamento};
  acc.Accertamenti =0;
  acc.Cadenze = 0;
  acc.LineeGuida= "";
  acc.ID=0;
  acc.Operazione="Nuovo";
  setAccertamento(acc);
  let responseProtocollo =  await unsplash
    .get('protocolloSanitario',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },params:{mansione:props.mansione,cliente:props.cliente}}
     );
    await setProtocolloSanitario(responseProtocollo.data.data);

    let responseAccertamenti =  await unsplash
    .get('accertamenti',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}
     );
    await setElencoAccertamenti(responseAccertamenti.data.data);

}

const handleClickOpen = () => {
  let acc = {...accertamento};
  acc.Accertamenti =0;
  acc.Cadenze = 0;
  acc.LineeGuida= "";
  acc.ID=0;
  acc.Operazione="Nuovo";
  setAccertamento(acc);
    setOpen(true);
  };

  const handleClose = () => {
    
    setOpen(false);
  };

  const handleDelete =async () => {
    let isExecuted = window.confirm("Sei sicuro di voler eliminare il record selezionato?");
  
if(isExecuted){
  try{
    const responseDeleteProtocollo = await unsplash
    .delete('protocolloSanitario',
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },
      data: {
        ID: accertamento.ID
      
    }});
    handleOpen();
    alert("record cancellato con successo")
  }catch{
    alert("errore nella cancellazione del record")
  }
}



  };


  const handleSave =async () => {
let a = {...accertamento};
a.Cliente = props.cliente;
a.Mansione = props.mansione;
console.log(a)
if (accertamento.Operazione== "Nuovo"){
  try{
  const responseProtocolloNew = await unsplash.post('protocolloSanitario',{protocollo:a},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }});
  alert("creato");
}catch{
  alert("errore nella creazione")
}
}else{

  try{
    const responseProtocolloEdit= await unsplash.put('protocolloSanitario',{protocollo:a},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }});
    alert("modificato");
  }catch{
    alert("errore nella modifica")
  }
}

    handleOpen();
  }

return (
<>
    <CButton onClick={() =>{handleOpen();setVisible(!visible)}} >{props.title}</CButton>
  
    <CModal alignment="center" size="lg" visible={visible}  onClose={() => setVisible(false)}>
      <CModalHeader>
        <CModalTitle>{props.descrizione}</CModalTitle>
      </CModalHeader>
      <CModalBody>
      <CButton style={{marginBottom:"10px"}} onClick={handleClickOpen}>Aggiungi</CButton>
      <CButton style={{marginBottom:"10px",marginLeft:"10px",display:accertamento.ID===0?"none":""}} onClick={()=>{setOpen(true);}}>Modifica</CButton>
      <CButton style={{marginBottom:"10px",marginLeft:"10px",display:accertamento.ID===0?"none":""}} color="danger" onClick={()=>handleDelete()}>Elimina</CButton>
      
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{accertamento.Operazione}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{marginTop:"10px"}}>
          <Grid item xs={12} >
          <FormControl fullWidth>
  <InputLabel id="demo-multiple-name-label">Mansione</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          defaultValue={accertamento.Accertamenti}
      
            onChange={(e) => {
              let a = {...accertamento}
              a.Accertamenti = e.target.value;
              setAccertamento(a);
            }
          }
          input={<OutlinedInput label="Name" />}
        >
          {elencoAccertamenti?.map((accertamento) => (
            <MenuItem
              key={accertamento.ID}
              value={accertamento.ID}
            
            >
              {accertamento.Descrizione}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
        <Grid item xs={12} >
        <TextField
          id="outlined-read-only-input"
          label="Cadenze"
          Name="Cadenze"
          type="number"
          value={accertamento.Cadenze}
          onChange={(e) => {
            let a = {...accertamento}
            a.Cadenze = e.target.value;
            setAccertamento(a);
          }
          }
          fullWidth
        />
        </Grid>
        <Grid item xs={12} >
        <TextField
          id="outlined-read-only-input"
          label="Linee Guida"
          Name="LineeGuida"
          value={accertamento.LineeGuida}
          onChange={(e) => {
            let a = {...accertamento}
            a.LineeGuida = e.target.value;
            setAccertamento(a);
          }
          }
          fullWidth
        />
         </Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
        <CButton onClick={handleSave}>Salva</CButton>
        <CButton  onClick={handleClose}>Annulla</CButton>
        
        </DialogActions>
      </Dialog>
      <div style={{ height: 400, width: '100%' }}>
   <DataGrid 
   experimentalFeatures={{ newEditingApi: true }} 
   
         localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
         rows={protocollo}
         getRowId={protocollo => protocollo.ID}
         columns={columns}
      onRowClick={(params) => { //popolo ma non apro
        let acc = {...accertamento};
        acc.Accertamenti = params.row.Accertamenti;
        acc.Cadenze = params.row.Cadenze;
        acc.LineeGuida= params.row.LineeGuida;
        acc.ID = params.row.ID;
        acc.Operazione="Modifica";
        setAccertamento(acc);
  
        }}
       onRowDoubleClick={(params) => { //popolo e apro
      let acc = {...accertamento};
      acc.Accertamenti = params.row.Accertamenti;
      acc.Cadenze = params.row.Cadenze;
      acc.LineeGuida= params.row.LineeGuida;
      acc.ID = params.row.ID;
      acc.Operazione="Modifica";
      setAccertamento(acc);
      setOpen(true);

      }}
       />

      
       </div>
   
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={() => setVisible(false)}>
          Chiudi
        </CButton>
        <CButton color="primary"  >Salva</CButton>
      </CModalFooter>
    </CModal>
    </>)

}
export default Mansioni;